module.exports = __webpack_public_path__ + "static/scale-model-of-world's-largest-wren-statue-in-topeka-kansas-26179a5ebce45c8b43a08701dfe8210a.png";